import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import WelcomeModal from '../components/WelcomeModal';
import { Link } from 'react-router-dom';
import { ChevronRight, Calendar, MapPin, Clock, ArrowRight } from 'lucide-react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../components/ui/accordion';
import jghospital from "../assets/jghospital.jpg";
import jgcollege from "../assets/jgcollege.jpg";
import jghospital2 from "../assets/jghospital2.jpg";
import collegefront from "../assets/jgcollegefront.jpg";

// const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
// const API = `${BACKEND_URL}/api`;

const Home = () => {
  const [liveUpdates, setLiveUpdates] = useState([]);
  const [ceoMessage, setCeoMessage] = useState(null);
  const [galleryImages, setGalleryImages] = useState([]);
  const [faqs, setFaqs] = useState([]);
  const [currentBanner, setCurrentBanner] = useState(0);

  const banners = [
  jghospital,
  jgcollege,
  jghospital2
];


  useEffect(() => {
  const interval = setInterval(() => {
    setCurrentBanner((prev) => (prev + 1) % banners.length);
  }, 4000); // 4 seconds

  return () => clearInterval(interval);
}, []);

  useEffect(() => {
    fetchLiveUpdates();
    fetchCEOMessage();
    fetchGalleryImages();
    fetchFAQs();
  }, []);

  const fetchLiveUpdates = async () => {
    try {
      const response = await axios.get(`http://3.109.108.187/api/live-updates`);
      setLiveUpdates(response.data.slice(0, 3));
    } catch (error) {
      console.error('Error fetching live updates:', error);
    }
  };

  const fetchCEOMessage = async () => {
    try {
      const response = await axios.get(`http://3.109.108.187/api/ceo-message`);
      setCeoMessage(response.data);
    } catch (error) {
      console.error('Error fetching CEO message:', error);
    }
  };

  const fetchGalleryImages = async () => {
    try {
      const response = await axios.get(`http://3.109.108.187/api/gallery`);
      setGalleryImages(response.data.slice(0, 8));
    } catch (error) {
      console.error('Error fetching gallery images:', error);
    }
  };

  const fetchFAQs = async () => {
    try {
      const response = await axios.get(`http://3.109.108.187/api/faqs`);
      setFaqs(response.data.slice(0, 5));
    } catch (error) {
      console.error('Error fetching FAQs:', error);
    }
  };

  // const reels = [
  //   'https://images.unsplash.com/photo-1703045199207-5312874d9e54',
  //   'https://images.unsplash.com/photo-1645694413160-fddc7f0feb5d',
  //   'https://images.unsplash.com/photo-1558380366-faa32a1c7f9f',
  //   'https://images.unsplash.com/photo-1600955800300-5beffd81f099'
  // ];

  const reels = [
  "DRhUKcrkx2J",
  "DQlKv2pE-S3",
  "DQmC342k6tH",
  "DRqnfTKk-cP"
];


  return (
    <div className="min-h-screen bg-white" data-testid="home-page">
      <WelcomeModal />
      <Navbar />

      {/* Hero Banner */}
      <section className="relative h-[600px] mt-20" data-testid="hero-banner">
        {banners.map((img, index) => (
            <img
              key={index}
              src={img}
              alt={`banner-${index}`}
              className={`w-full h-full object-cover absolute inset-0 transition-opacity duration-1000
                ${index === currentBanner ? "opacity-100" : "opacity-0"}
              `}
            />
          ))}
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-transparent flex items-center">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
            <div className="max-w-2xl slide-in-left">
              <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
                Celebrating<br />
                <span className="text-orange-400">75 Years</span> of<br />
                Excellence
              </h1>
              <p className="text-xl text-gray-200 mb-8 leading-relaxed">
                Join us in the grand celebration of Amrut Mahotsav as we honor our legacy and embrace the future.
              </p>
              <div className="flex flex-wrap gap-4">
                <Link to="/registration" data-testid="hero-register-btn">
                  <button className="btn-primary">
                    Register Now <ChevronRight className="inline ml-2" size={20} />
                  </button>
                </Link>
                <Link to="/events" data-testid="hero-explore-btn">
                  <button className="btn-secondary">
                    Explore Events
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Live Updates */}
      <section className="section-spacing bg-gradient-to-br from-orange-50 to-white" data-testid="live-updates-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12 fade-in">
            <h2 className="text-4xl sm:text-5xl font-bold mb-4 text-gray-800">
              Today's <span className="text-gradient">Live Updates</span>
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-orange-500 to-green-600 mx-auto"></div>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {liveUpdates.map((update, index) => (
              <div key={update.id} className="bg-white rounded-xl shadow-lg p-6 hover-lift" data-testid={`live-update-${index}`}>
                <div className="flex items-center space-x-2 text-orange-600 mb-3">
                  <div className="w-2 h-2 rounded-full bg-green-500 animate-pulse"></div>
                  <span className="text-sm font-semibold">LIVE</span>
                </div>
                <h3 className="text-xl font-bold mb-2 text-gray-800">{update.title}</h3>
                <p className="text-gray-600 mb-4">{update.description}</p>
                <div className="flex items-center text-sm text-gray-500">
                  <Calendar size={16} className="mr-2" />
                  {update.event_date}
                </div>
              </div>
            ))}
          </div>

          {liveUpdates.length === 0 && (
            <div className="text-center text-gray-500 py-12">
              <p>No live updates available at the moment.</p>
            </div>
          )}

          <div className="text-center mt-8">
            <Link to="/live-updates" data-testid="view-all-updates-btn">
              <button className="btn-primary">View All Updates</button>
            </Link>
          </div>
        </div>
      </section>

      {/* About Amrut Mahotsav */}
      <section className="relative section-spacing" data-testid="about-amrut-section">
        <div className="absolute inset-0 opacity-10">
          <img
            src="https://images.unsplash.com/flagged/photo-1580408453889-ed5e1b51924a"
            alt="Background"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto text-center fade-in">
            <h2 className="text-4xl sm:text-5xl font-bold mb-8 text-gray-800">
              About <span className="text-gradient">Amrut Mahotsav</span>
            </h2>
            <div className="glass-effect rounded-2xl p-8 md:p-12 shadow-xl">
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                Amrut Mahotsav marks the momentous occasion of JG Group's 75 years of dedicated service to education and the nation. This golden jubilee celebration is a testament to our unwavering commitment to excellence, innovation, and nation-building.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                Throughout this year-long celebration, we honor our rich heritage while embracing the future with renewed vigor. Join us as we celebrate the achievements of thousands of alumni, faculty, and students who have contributed to our glorious legacy.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* About College and Event */}
      <section className="section-spacing bg-gradient-to-br from-green-50 to-white" data-testid="about-college-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            <div className="slide-in-left">
              <img
                src={collegefront}
                alt="JG Group Campus"
                className="rounded-2xl shadow-2xl w-full"
              />
            </div>
            <div className="slide-in-right">
              <h2 className="text-4xl sm:text-5xl font-bold mb-6 text-gray-800">
                About <span className="text-gradient">JG Group</span>
              </h2>
              <p className="text-lg text-gray-700 mb-4 leading-relaxed">
                Shri J. G. Co-Operative Hospital and Research Institute, Ghataprabha is a state level Charitable Co-operative Society and a trust established in the year 1951.
              </p>
              <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                We are providing satisfactory and high quality health services in Medical, Nursing, Education and Social services to rural and needy people.
              </p>
              <ul className="space-y-3 mb-8">
                <li className="flex items-center text-gray-700">
                  <div className="w-2 h-2 rounded-full bg-orange-500 mr-3"></div>
                  50,000+ Alumni
                </li>
                <li className="flex items-center text-gray-700">
                  <div className="w-2 h-2 rounded-full bg-orange-500 mr-3"></div>
                  100+ Academic Programs
                </li>
                <li className="flex items-center text-gray-700">
                  <div className="w-2 h-2 rounded-full bg-orange-500 mr-3"></div>
                  Award-winning Research Centers
                </li>
              </ul>
              <Link to="/about" data-testid="learn-more-btn">
                <button className="btn-primary">Learn More</button>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* CEO Message */}
      {ceoMessage && (
        <section className="section-spacing" data-testid="ceo-message-section">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="bg-gradient-to-br from-orange-500 to-green-600 rounded-3xl shadow-2xl overflow-hidden">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-0">
                <div className="p-8 md:p-12 text-white flex flex-col justify-center">
                  <div className="text-sm font-semibold mb-2 text-orange-100">MESSAGE FROM</div>
                  <h2 className="text-3xl md:text-4xl font-bold mb-2">{ceoMessage.name}</h2>
                  <p className="text-orange-100 mb-6">{ceoMessage.designation}</p>
                  <div className="text-lg leading-relaxed text-white/90">
                    {ceoMessage.message}
                  </div>
                </div>
                <div className="h-64 md:h-auto">
                 <img
                    src={`http://3.109.108.187/assets/${ceoMessage.image_url}`}
                    alt={ceoMessage.name}
                    className="w-full h-full object-cover"
                  />

                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Documentary Video */}
      <section className="section-spacing bg-gray-100" data-testid="documentary-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12 fade-in">
            <h2 className="text-4xl sm:text-5xl font-bold mb-4 text-gray-800">
              Our <span className="text-gradient">Documentary</span>
            </h2>
            <p className="text-lg text-gray-600">Watch the inspiring journey of 75 years</p>
            <div className="w-24 h-1 bg-gradient-to-r from-orange-500 to-green-600 mx-auto mt-4"></div>
          </div>
          <div className="max-w-4xl mx-auto">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl" style={{ paddingBottom: '56.25%' }}>
              <iframe
                className="absolute top-0 left-0 w-full h-full"
                src="https://www.youtube.com/embed/NA470no2JWY?si=E4onr4ik8Rb31Uwd"
                title="JG Group Documentary"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                data-testid="documentary-video"
              ></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* Glimpse of Events - Reels */}
      {/* <section className="section-spacing" data-testid="reels-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12 fade-in">
            <h2 className="text-4xl sm:text-5xl font-bold mb-4 text-gray-800">
              Glimpse of <span className="text-gradient">Events</span>
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-orange-500 to-green-600 mx-auto"></div>
          </div>
          
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
            {reels.map((reel, index) => (
              <div key={index} className="relative aspect-[9/16] rounded-xl overflow-hidden shadow-lg hover-lift" data-testid={`reel-${index}`}>
                <img
                  src={reel}
                  alt={`Event Reel ${index + 1}`}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent flex items-end p-4">
                  <div className="text-white">
                    <p className="font-semibold text-sm">Event Highlight {index + 1}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center">
            <a 
              href="https://instagram.com" 
              target="_blank" 
              rel="noopener noreferrer" 
              data-testid="more-reels-link"
              className="inline-flex items-center text-orange-600 font-semibold hover:text-orange-700 transition-colors"
            >
              More Reels - Visit Our Instagram <ArrowRight className="ml-2" size={20} />
            </a>
          </div>
        </div>
      </section> */}
      <section className="section-spacing" data-testid="reels-section">
  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    
    <div className="text-center mb-12 fade-in">
      <h2 className="text-4xl sm:text-5xl font-bold mb-4 text-gray-800">
        Glimpse of <span className="text-gradient">Events</span>
      </h2>
      <div className="w-24 h-1 bg-gradient-to-r from-orange-500 to-green-600 mx-auto"></div>
    </div>

    {/* --- Instagram Reels Embed Grid --- */}
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 mb-8">
      {reels.map((reelId, index) => (
        <div
          key={index}
          className="rounded-xl overflow-hidden shadow-lg"
          data-testid={`reel-${index}`}
        >
          <iframe
            src={`https://www.instagram.com/reel/${reelId}/embed`}
            className="w-full h-[500px] rounded-xl"
            allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
          ></iframe>
        </div>
      ))}
    </div>

    <div className="text-center">
      <a 
        href="https://www.instagram.com/jgco_official1951/"
        target="_blank"
        rel="noopener noreferrer"
        data-testid="more-reels-link"
        className="inline-flex items-center text-orange-600 font-semibold hover:text-orange-700 transition-colors"
      >
        More Reels - Visit Our Instagram <ArrowRight className="ml-2" size={20} />
      </a>
    </div>

  </div>
</section>


      {/* Gallery Preview */}
      <section className="section-spacing bg-gray-50" data-testid="gallery-preview-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12 fade-in">
            <h2 className="text-4xl sm:text-5xl font-bold mb-4 text-gray-800">
              Event <span className="text-gradient">Gallery</span>
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-orange-500 to-green-600 mx-auto"></div>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
            {galleryImages.map((image, index) => (
              <div key={image.id} className="gallery-item aspect-square" data-testid={`gallery-image-${index}`}>
                <img
                  src={`http://3.109.108.187/assets/${image.image_url}`}
                  alt={image.title}
                  className="rounded-xl"
                />

                <div className="overlay">
                  <p className="text-white font-semibold">{image.title}</p>
                </div>
              </div>
            ))}
          </div>

          {galleryImages.length === 0 && (
            <div className="text-center text-gray-500 py-12">
              <p>Gallery images will be added soon.</p>
            </div>
          )}

          <div className="text-center">
            <Link to="/gallery" data-testid="view-full-gallery-btn">
              <button className="btn-primary">View Full Gallery <ChevronRight className="inline ml-2" size={20} /></button>
            </Link>
          </div>
        </div>
      </section>

      {/* Mini Banner */}
      <section className="relative py-20" data-testid="mini-banner">
        <div className="absolute inset-0 bg-gradient-to-r from-orange-600 via-orange-500 to-green-600"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">Amrut Mahotsav 2025</h2>
          <p className="text-xl md:text-2xl mb-8">75 Years of Excellence | Legacy of Service | Future of Innovation</p>
          <Link to="/registration" data-testid="mini-banner-register-btn">
            <button className="bg-white text-orange-600 px-8 py-4 rounded-full font-bold text-lg hover:shadow-2xl transition-all">
              Be Part of History
            </button>
          </Link>
        </div>
      </section>

      {/* FAQs */}
      <section className="section-spacing" data-testid="faqs-section">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12 fade-in">
            <h2 className="text-4xl sm:text-5xl font-bold mb-4 text-gray-800">
              Frequently Asked <span className="text-gradient">Questions</span>
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-orange-500 to-green-600 mx-auto"></div>
          </div>

          {faqs.length > 0 ? (
            <Accordion type="single" collapsible className="space-y-4" data-testid="faq-accordion">
              {faqs.map((faq, index) => (
                <AccordionItem key={faq.id} value={`faq-${index}`} className="bg-white rounded-lg shadow-md px-6" data-testid={`faq-item-${index}`}>
                  <AccordionTrigger className="text-left font-semibold text-gray-800 hover:text-orange-600">
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-gray-600">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          ) : (
            <div className="text-center text-gray-500 py-12">
              <p>FAQs will be added soon.</p>
            </div>
          )}

          <div className="text-center mt-8">
            <Link to="/faqs" data-testid="view-all-faqs-btn">
              <button className="btn-secondary">View All FAQs</button>
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Home;